module.exports = __webpack_public_path__ + "img/bergen_transparant_achtergrond_600.49bdd3eb.png";